<template>
  <div class="privacy">
    {{ $t('By clicking continue, you accept our') }}<br /><a href="#" @click="handleGotoPrivacy(licenseUrl)">{{ $t('License Agreement') }}</a> {{ $t('and') }}
    <a href="#" @click="handleGotoPrivacy(privacyUrl)">{{ $t('Privacy Policy') }}</a>
  </div>
</template>

<script setup>
import enums from '@/libs/enums'
import { redirectUrl } from '@/services/login'
import { getCurrentInstance } from 'vue'

const { $t } = getCurrentInstance().proxy

const { licenseUrl, privacyUrl } = enums.websiteUrl

// 隐私协议
const handleGotoPrivacy = url => {
  redirectUrl('href', url)
  return false
}
</script>
